import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { Box, CircularProgress } from '@mui/material';

const ProtectedRoute = ({ child, roles }) => {
  const { user, loading } = useAuth();
  const location = useLocation()

  if (loading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="200px">
        <CircularProgress />
      </Box>
    )
  }
  
  if (!user) {
    return (
      <Navigate to="/" replace state={{ from: location }} />
    )
  }

  if (roles && !roles.includes(user.role)) return <Navigate to="/dashboard" replace />;
  return child;
};

export default ProtectedRoute;
